'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _createCmsComponent = require('../../utils/create-cms-component');

var _createCmsComponent2 = _interopRequireDefault(_createCmsComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @jsx dom */
var render = function render(_ref) {
	var props = _ref.props;
	var color = props.color,
	    marginBottom = props.marginBottom,
	    marginTop = props.marginTop,
	    spacerType = props.spacerType;


	var legacyStyles = {
		'margin-top': marginTop,
		'margin-bottom': marginBottom
	};

	var border = {
		'border': 0,
		'border-bottom': '1px ' + spacerType + ' ' + color
	};

	var style = props.styleClasses.Spacer ? border : Object.assign({}, legacyStyles, border);

	return (0, _createCmsComponent2.default)((0, _magicVirtualElement2.default)('hr', { style: style, 'data-style-attr': 'Spacer', 'class': ['CMS-Spacer', props.class, props.styleClasses.Spacer] }), props);
};

exports.default = { render: render };